import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState, useMemo } from 'react';
import { offset } from '@floating-ui/core';
import { useFloating, useFocus, useInteractions, useDismiss, flip, autoUpdate, size } from '@floating-ui/react';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import { ANIMATION_DURATION_MS, DEFAULT_Z_INDEX } from './constants.js';
import { FloatingWrapper, ReferenceWrapper } from './styled.js';
export const InputPopover = memo(function InputPopover({ content, open, matchWidth = true, zIndex = DEFAULT_Z_INDEX, children, dataTestId, closeOnContentClick = false, }) {
    const [isFocused, setIsFocused] = useState(false);
    const isVisible = open && isFocused;
    const handleContentMouseDown = () => {
        if (closeOnContentClick) {
            setIsFocused(false);
        }
    };
    const middleware = useMemo(() => [
        offset(4),
        flip({
            fallbackPlacements: ['top-start', 'top-end'],
        }),
        ...(matchWidth
            ? [
                size({
                    apply({ rects, elements }) {
                        elements.floating.style.width = `${rects.reference.width}px`;
                    },
                }),
            ]
            : []),
    ], [matchWidth]);
    const { refs, floatingStyles, context, placement } = useFloating({
        open: isVisible,
        onOpenChange: setIsFocused,
        placement: 'bottom-start',
        whileElementsMounted: autoUpdate,
        middleware,
    });
    const isTop = placement.startsWith('top');
    const focus = useFocus(context);
    const dismiss = useDismiss(context, { enabled: isVisible });
    const { getReferenceProps, getFloatingProps } = useInteractions([focus, dismiss]);
    return (_jsxs(_Fragment, { children: [_jsx(ReferenceWrapper, { ref: refs.setReference, ...getReferenceProps(), "data-testid": dataTestId, children: children }), createPortal(_jsx(CSSTransition, { in: isVisible, timeout: ANIMATION_DURATION_MS, unmountOnExit: true, children: _jsx(FloatingWrapper
                // eslint-disable-next-line react-hooks/refs
                , { 
                    // eslint-disable-next-line react-hooks/refs
                    ref: refs.setFloating, ...getFloatingProps({ onMouseDown: handleContentMouseDown }), style: floatingStyles, $zIndex: zIndex, $visible: isVisible, $isTop: isTop, "data-testid": dataTestId ? `${dataTestId}-popover` : undefined, children: content }) }), document.body)] }));
});
